import React from "react";
import range from "lodash.range";
import useStore from "../store/useStore";
import Solution from "./Solution";
import Search from "./Search";

const ITEMS_PER_PAGE = 20;

const PaginatedSolutions = ({ className }) => {
  const solutions = useStore((state) => state.filteredAndSearchedSolutions)();

  const totalRecords = solutions.length;
  const totalPages = Math.ceil(totalRecords / ITEMS_PER_PAGE);
  const pageNumbers = range(1, totalPages + 1);

  const currentPage = useStore((state) => state.currentPage);
  const setCurrentPage = useStore((state) => state.setCurrentPage);
  const translations = useStore((state) => state.translations);

  const getSolutionsForCurrentPage = () => {
    const startIndex = currentPage * ITEMS_PER_PAGE;
    const endIndex = Math.min((currentPage + 1) * ITEMS_PER_PAGE, totalRecords);
    return solutions.slice(startIndex, endIndex);
  };

  const pageText = () => {
    let text = translations.pageText.data;
    text = text.replace("{0}", currentPage + 1);
    text = text.replace("{1}", totalPages);
    return text;
  };

  const getPagination = () => {
    if (totalPages <= 1) {
      return null;
    }

    return (
      <nav aria-label="Solutions navigation" className="pagination__wrapper">
        <ul className="pagination">
          <li className={currentPage === 0 ? "disabled" : ""}>
            <button
              type="button"
              onClick={() => setCurrentPage(Math.max(0, currentPage - 1))}
            >
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>

          {pageNumbers.map((page, index) => (
            <li className={index === currentPage ? "active" : ""} key={page}>
              <button type="button" onClick={() => setCurrentPage(index)}>
                {page}
              </button>
            </li>
          ))}

          <li className={currentPage === totalPages - 1 ? "disabled" : ""}>
            <button
              type="button"
              onClick={() =>
                setCurrentPage(Math.min(currentPage + 1, totalPages - 1))
              }
            >
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    );
  };

  return (
    <div className={className}>
      <div className="row solutions__header">
        <div className="solutions__pagination-information col-md-2  col-sm-3">
          <span data-translate={translations.pageText.key}>{pageText()}</span>
          <br />
          {totalRecords}{" "}
          <span data-translate={translations.results.key}>
            {" "}
            {translations.results.data}{" "}
          </span>
        </div>
        <Search className="col-md-10 col-sm-9" />
      </div>
      <div className="solutions__list">
        {getSolutionsForCurrentPage().map((solution) => (
          <Solution solution={solution} key={solution.uid} />
        ))}
      </div>
      {getPagination()}
    </div>
  );
};
export default PaginatedSolutions;
